import type { ResourceFilterKey } from '@/lib/api/types/itemFilters';

export const OPEN_POSITION_PICKLIST_FILTERS = [
  'locationId',
  'roleId',
  'skillId',
] as const satisfies readonly ResourceFilterKey[];

export const OPEN_POSITION_FILTER_KEYS = [...OPEN_POSITION_PICKLIST_FILTERS] as const;
export type OpenPositionFilterKey = (typeof OPEN_POSITION_FILTER_KEYS)[number];
export const getOpenPositionTableFilters = () => [...OPEN_POSITION_FILTER_KEYS] as const;
